export default __webpack_public_path__ + "static/media/spark_27.da283ee2.png";